import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Inbox } from "lucide-react";
import { API, authHeaders } from "./AdminPage";
import { useAdminT } from "./adminI18n";

export const MessagesTab = () => {
  const { t } = useAdminT();
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/admin/contacts`, { headers: authHeaders() })
      .then((res) => setMessages(res.data))
      .catch(() => setMessages([]));
  }, []);

  if (messages === null) {
    return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-luxury-gold animate-spin" /></div>;
  }

  return (
    <div data-testid="admin-messages-tab">
      <h2 className="font-serif text-3xl text-luxury-bone mb-8">{t("الرسائل الواردة")} ({messages.length})</h2>
      {messages.length === 0 ? (
        <div className="text-center py-16 text-luxury-gray">
          <Inbox className="w-10 h-10 mx-auto mb-4 text-luxury-gold" strokeWidth={1} />
          {t("لا توجد رسائل بعد")}
        </div>
      ) : (
        <div className="space-y-4">
          {messages.map((m, i) => (
            <div key={m.id || i} data-testid={`admin-message-row-${i}`} className="bg-luxury-surface border border-luxury-border p-6">
              <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                <div className="flex items-center gap-4">
                  <p className="text-luxury-bone font-semibold">{m.name}</p>
                  <p className="text-luxury-gold text-sm" dir="ltr">{m.phone}</p>
                  <span className="text-xs border border-luxury-border text-luxury-gray rounded-full px-3 py-1">{m.interest}</span>
                </div>
                <p className="text-luxury-gray text-xs" dir="ltr">{m.created_at?.slice(0, 16).replace("T", " ")}</p>
              </div>
              <p className="text-luxury-gray leading-relaxed">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
